var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoPreview = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  fill: "none",
  viewBox: "0 0 120 120",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DEE7FA",
  d: "M29.55 14.67a1.98 1.98 0 0 1 2.36-1.5l73.42 16.37a1.98 1.98 0 0 1 1.5 2.37l-16.37 73.42a1.98 1.98 0 0 1-2.37 1.5L14.67 90.46a1.98 1.98 0 0 1-1.5-2.37z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9DAFF",
  fillRule: "evenodd",
  d: "M15.01 79.04 25.9 30.26l46.42-8.22 13.56 3.03 9.87 55.76-4.06 18.2-21.15 3.74L17.1 90.86 15 79.04Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#DEE7FA",
  d: "M4.98 39.52a1.98 1.98 0 0 1 1.6-2.3l74.08-13.1a1.98 1.98 0 0 1 2.3 1.6l13.1 74.07a1.98 1.98 0 0 1-1.6 2.3l-74.07 13.1a1.98 1.98 0 0 1-2.3-1.6L5 39.52Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#1186FA",
  d: "M15.88 55.68a1.98 1.98 0 0 1 1.6-2.3l58.48-10.34a1.98 1.98 0 0 1 2.3 1.6l5.17 29.24a1.98 1.98 0 0 1-1.6 2.3L23.35 86.51a1.98 1.98 0 0 1-2.3-1.6l-5.17-29.24Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.75 43.44a.99.99 0 0 1 .8-1.15l22.42-3.97a.99.99 0 0 1 1.14.8l.35 1.96a.99.99 0 0 1-.8 1.14L21.24 46.2a.99.99 0 0 1-1.15-.8l-.34-1.95Zm3.03 51.23a.99.99 0 0 1 .8-1.15l28.27-5a.99.99 0 0 1 1.15.8l.34 1.95a.99.99 0 0 1-.8 1.15l-28.26 5a.99.99 0 0 1-1.15-.8zm1.3 7.3a.99.99 0 0 1 .8-1.14l60.43-10.7a.99.99 0 0 1 1.14.8l.35 1.95a.99.99 0 0 1-.8 1.15l-60.43 10.7a.99.99 0 0 1-1.15-.8l-.34-1.95Zm-6.11-57.21a1.98 1.98 0 1 1-3.9.69 1.98 1.98 0 0 1 3.9-.7Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#095FF9",
  d: "M56.83 68.17a4.95 4.95 0 0 1 7.72-1.37l11.43 10.4-26.31 4.67z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#5CADFD",
  d: "M56.7 56.25a3.22 3.22 0 1 1-6.34 1.12 3.22 3.22 0 0 1 6.33-1.12Zm-17.96 9.14a4.95 4.95 0 0 1 7.74-1.37L63.3 79.45l-35.08 6.21L38.74 65.4Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#1186FA",
  d: "M107.4 98.73a12.62 12.62 0 1 1-25.25 0 12.62 12.62 0 0 1 25.24 0Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M100.03 94.07 90.11 104m0-9.92 9.92 9.92"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoPreview);
export default ForwardRef;